import type { SVGProps } from "react"

export const BatteryIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <rect x="7" y="3" width="10" height="18" rx="2" strokeWidth="1.75" />
    <rect x="10" y="1.5" width="4" height="2" rx="0.6" fill="currentColor" />
    <path
      d="M10 8.5h4M10 12h4M10 15.5h4"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
)
